import React from "react";
import { useNavigate } from "react-router-dom";
import { BreadcrumbItem, Col, Row } from "reactstrap";

const Breadcrumbs = ({ items }) => {
  const navigate = useNavigate();

  return (
    <Row>
      <Col>
        <ol className="breadcrumbs bg-transparent">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;

            return (
              <BreadcrumbItem key={index} className={isLast ? "active" : ""}>
                {isLast ? (
                  item.name
                ) : (
                  <a
                    className="items"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(item.link);
                    }}
                  >
                    {item.name}
                  </a>
                )}
              </BreadcrumbItem>
            );
          })}
        </ol>
      </Col>
    </Row>
  );
};

export default Breadcrumbs;
